import { presetName, presets, spanLabel } from "./date-range/model.js";
import { DateRangePanel } from "./date-range/panel.js";
import { FilterPill } from "./filter-pill.js";
import { CalendarDays } from "./icons.js";

/**
 * The report's date range, behind a pill. The panel and its arithmetic live in
 * `date-range/`, shared with the export popup, which draws the same calendar
 * inline.
 */
export function DateRangePill({
  from,
  to,
  today,
  onChange,
}: {
  readonly from: string;
  readonly to: string;
  /** Injected, so the presets are a value rather than a read of the clock. */
  readonly today: string;
  readonly onChange: (range: { readonly from: string; readonly to: string }) => void;
}) {
  // A preset says its name and, quieter, the days; any other range its days.
  const name = presetName(from, to, today);
  const span = spanLabel(from, to, today);
  return (
    <FilterPill
      label="Date range"
      value={name ?? span}
      {...(name === null ? {} : { detail: span })}
      icon={<CalendarDays className="pill-icon" aria-hidden="true" />}
    >
      {(close) => (
        <DateRangePanel
          from={from}
          to={to}
          today={today}
          presets={presets(today)}
          onPick={(range) => {
            onChange(range);
            close();
          }}
        />
      )}
    </FilterPill>
  );
}
